import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Categories } from './Categories';
import { Units } from './Units';
import { Coupons } from './Coupons';
import { RouteOrder } from './RouteOrder';
import { Announcements } from './Announcements';
import { FolderOpen, Ruler, Ticket, ArrowUpDown, Megaphone } from 'lucide-react';

export const MasterManagement = () => {
  const [activeTab, setActiveTab] = useState('categories');

  return (
    <div className="space-y-6 fade-in" data-testid="master-management-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">マスタ管理</h1>
        <p className="text-slate-500 mt-1">カテゴリ・単位・クーポン・表示順の管理</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="categories" className="flex items-center gap-1.5">
            <FolderOpen className="h-4 w-4" />カテゴリ
          </TabsTrigger>
          <TabsTrigger value="units" className="flex items-center gap-1.5">
            <Ruler className="h-4 w-4" />単位
          </TabsTrigger>
          <TabsTrigger value="coupons" className="flex items-center gap-1.5">
            <Ticket className="h-4 w-4" />クーポン
          </TabsTrigger>
          <TabsTrigger value="route-order" className="flex items-center gap-1.5">
            <ArrowUpDown className="h-4 w-4" />表示順
          </TabsTrigger>
          <TabsTrigger value="announcements" className="flex items-center gap-1.5">
            <Megaphone className="h-4 w-4" />お知らせ
          </TabsTrigger>
        </TabsList>

        <TabsContent value="categories" className="mt-4">
          <Categories />
        </TabsContent>
        <TabsContent value="units" className="mt-4">
          <Units />
        </TabsContent>
        <TabsContent value="coupons" className="mt-4">
          <Coupons />
        </TabsContent>
        <TabsContent value="route-order" className="mt-4">
          <RouteOrder />
        </TabsContent>
        <TabsContent value="announcements" className="mt-4">
          <Announcements />
        </TabsContent>
      </Tabs>
    </div>
  );
};
